//**auto-generated don't edit this code**//
import {ContractHttpClient, getClientConfig} from '@esgi/contracts';
import {Disposable} from '@esgi/core/service';
import {tableLevelInit} from './endpoints/table-level-init';
import {tableLevelBuildReport} from './endpoints/table-level-build-report';
import {tableLevelExportPdf} from './endpoints/table-level-export-pdf';
import {tableLevelExportExcel} from './endpoints/table-level-export-excel';
import {studentLevelNotes} from './endpoints/student-level-notes';
import {studentLevelExportPdf} from './endpoints/student-level-export-pdf';
import {updateShowBaseLine} from './endpoints/update-show-base-line';
import {updateShowNotes} from './endpoints/update-show-notes';
import {updateShowSummary} from './endpoints/update-show-summary';
import {updateShowInColor} from './endpoints/update-show-in-color';
import {updateReportSettings} from './endpoints/update-report-settings';

export class V2TeachersPagesReportsRubricResultsController implements Disposable {
	private httpClientConfig = getClientConfig('esgi-apigateway');
	private httpClient: ContractHttpClient = new ContractHttpClient(this.httpClientConfig);

	public tableLevelInit = tableLevelInit(this.httpClient);
	public tableLevelBuildReport = tableLevelBuildReport(this.httpClient);
	public tableLevelExportPdf = tableLevelExportPdf(this.httpClient);
	public tableLevelExportExcel = tableLevelExportExcel(this.httpClient);
	public studentLevelNotes = studentLevelNotes(this.httpClient);
	public studentLevelExportPdf = studentLevelExportPdf(this.httpClient);
	public updateShowBaseLine = updateShowBaseLine(this.httpClient);
	public updateShowNotes = updateShowNotes(this.httpClient);
	public updateShowSummary = updateShowSummary(this.httpClient);
	public updateShowInColor = updateShowInColor(this.httpClient);
	public updateReportSettings = updateReportSettings(this.httpClient);

	public dispose(): void {
		this.httpClient?.destroy();
	}
}
